import {useListView} from './core/ListViewProvider'
import {IndemnityItemsTable} from './table/IndemnityItemsTable'
import {KTCard} from '../../../../../../_metronic/helpers'

const IndemnityItemsList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <div className='py-3'>
        <KTCard>
          <IndemnityItemsTable />
        </KTCard>
      </div>
      {itemIdForUpdate !== undefined}
      {/* {itemIdForUpdate !== undefined && <UserEditModal />} */}
    </>
  )
}

const IndemnityItemsListWrapper = () => <IndemnityItemsList />

export {IndemnityItemsListWrapper}
